import { getJson } from '../common';
export async function getEntrypoints(url, cache, signal) {
    try {
        return (await getJson(url, {
            cache,
            signal,
        })).data;
    }
    catch (_a) {
        return { css: ['index.css'], js: ['index.js'] };
    }
}
//# sourceMappingURL=get-entry-points.js.map